import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  CategorieFormulaireDto, SaveModeleFormulaireDto,
  CreateRessourceMultimediaDto, IModeleFormulaireWebServiceClient, ModeleFormulaireDto,
} from "@common/resources/resources";
import {AsiFileService, AsiSelectComponent} from "@asi-ngtools/lib";
import {Router, ActivatedRoute} from '@angular/router';
import {ResourceMultimediaPipe} from "app/common/utils/image/resource.multimedia.pipe";
import {ArianeElement, ArianeStore, WaitingModalService} from "@digicerba/common";
import * as lodash from "lodash";
import { FormulaireDematValidators } from '@common/validators/formdemat.validator';

@Component({
  selector: 'app-gestion-model',
  templateUrl: './gestion-modele.component.html',
})
export class GestionModeleComponent implements OnInit {

  forUpdate: boolean = false;

  modeleFormulaireDto: ModeleFormulaireDto;
  modelForm: FormGroup;
  categories: Array<CategorieFormulaireDto> = [];
  tags: Array<string> = [];
  selectedTags: Array<string> = [];
  image: string = null;
  htmlFile: string = null;
  submittable: boolean = true;

  @ViewChild('tagSelectComponent') tagSelect: AsiSelectComponent;

  constructor(private fb: FormBuilder,
              private modeleFormulaireWebService: IModeleFormulaireWebServiceClient,
              private router: Router,
              private fileUtils: AsiFileService,
              private activatedRoute: ActivatedRoute,
              private resourcePipe: ResourceMultimediaPipe,
              private arianeStore: ArianeStore,
              private waitingModal: WaitingModalService) {
  }

  ngOnInit() {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "Dossiers bloqués",
        route: ""
      },
      {
        libelle: "Administration",
        route: "/admin"
      },
      {
        libelle: "Gestion",
        route: "/gestion"
      }
    ];

    this.arianeStore.updateElements(arianeElements);

    this.modeleFormulaireDto = this.activatedRoute.snapshot.data['modeleFormulaire'];
    this.categories = this.activatedRoute.snapshot.parent.data['categories'];
    this.tags = this.activatedRoute.snapshot.parent.data['tags'];

    this.modeleFormulaireDto ? this.forUpdate = true : (this.forUpdate ? this.forUpdate = false : null);

    if (this.modeleFormulaireDto) {
      this.loadFiles();
    }

    this.modelForm = this.fb.group({
      titre: [this.modeleFormulaireDto ? this.modeleFormulaireDto.titre : null, Validators.required],
      image: [null, Validators.required],
      tags: [this.modeleFormulaireDto ? this.modeleFormulaireDto.tags.split(";") : null, Validators.required],
      categorie: this.modeleFormulaireDto ? this.categories.find(cat => cat.id == this.modeleFormulaireDto.idCategorieFormulaire) : null,
      modifiable: this.modeleFormulaireDto ? this.modeleFormulaireDto.modifiable : false,
      modelHTML: [null, !this.forUpdate ? [ Validators.required, FormulaireDematValidators.fileExtensionValidator(['.html','.HTML'])] : []]
    });

    this.updateSelectedTags();
  }

  loadFiles() {
    this.image = this.resourcePipe.transform(this.modeleFormulaireDto.idImage);
    this.htmlFile = this.modeleFormulaireDto.urlHtmlFile;
  }

  async submit() {
    this.waitingModal.openModal();
    this.submittable = !this.submittable;
    const nomValide = await this.modeleFormulaireWebService.nomDisponible(this.modelForm.value.titre, this.forUpdate ? this.modeleFormulaireDto.id : -1 ).toPromise();
    if (!this.modelForm.valid || !nomValide) {
      this.submittable = !this.submittable;

      if(!nomValide){
        this.modelForm.controls.titre.setErrors({'nomDisponible': true})
      }

      this.waitingModal.closeModal();
      return;
    }

    let modeleToSave = new SaveModeleFormulaireDto;
    let modelFormValue = this.modelForm.value;

    modeleToSave.titre = modelFormValue.titre;
    modeleToSave.modifiable = modelFormValue.modifiable;
    modeleToSave.tags = "";
    for (let i = 0; i < modelFormValue.tags.length; i++) {
      modeleToSave.tags += modelFormValue.tags[i];
      if (i != modelFormValue.tags.length - 1) {
        modeleToSave.tags += ";";
      }
    }
    modeleToSave.forUpdate = this.forUpdate;
    modelFormValue.categorie != null ? modeleToSave.idCategorieFormulaire = modelFormValue.categorie.id : modeleToSave.idCategorieFormulaire = null;
    if (!this.forUpdate) {
      const file = await this.fileUtils.uploadFile("/formulaire-demat/api/modeleformulaire/upload", modelFormValue.modelHTML).toPromise();
      modeleToSave.urlHtmlFile = file._body;
      modeleToSave.fileName = file._body;
    }
    else {
      modeleToSave.id = this.modeleFormulaireDto.id;
    }

    if (modelFormValue.image != null) {
      let imageDto = new CreateRessourceMultimediaDto;

      let fichier: File = modelFormValue.image;
      let result = await this.fileUtils.fileToBase64(fichier).toPromise();

      result = result.substring(result.indexOf(",") + 1);
      imageDto.content = result.toString();
      imageDto.name = fichier.name;
      imageDto.mimeType = fichier.type;
      imageDto.size = fichier.size;

      modeleToSave.image = imageDto;

      this.SaveAndRedirect(modeleToSave);

    }
  }

  SaveAndRedirect(modeleToSave: SaveModeleFormulaireDto) {
    this.modeleFormulaireWebService.enregistrerModeleFormulaire(modeleToSave).subscribe((response) => {
      this.waitingModal.closeModal();
      if (response) {
        this.router.navigate(['/cerba/admin']);
      }
      },
      () => {
        this.waitingModal.closeModal();
        this.submittable = !this.submittable;
      });
  }

  updateSelectedTags() {
    if (this.modelForm.value.tags) {
      this.selectedTags = [].concat(this.modelForm.value.tags);
    } else {
      this.selectedTags = [];
    }
  }

  removeTag(tagToRemove: string) {
    let data = lodash.find(this.tagSelect.selectDatas, data => {
      return data.value === tagToRemove;
    });
    data.selected = false;

    this.tagSelect.selectValue(null, data);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/admin/gestion-modele/gestion-modele.component.ts